import React from "react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { LogIn, Shield, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminLogin() {
  const { login, user, loading } = useAuth();

  if (loading) {
    return <div className="min-h-screen grid place-items-center text-slate-600">Loading...</div>;
  }

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-b from-slate-50 to-white p-6">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white shadow-xl p-8">
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 rounded-xl bg-slate-900 text-white grid place-items-center font-bold">
            <Shield className="h-6 w-6 text-cyan-400" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-cyan-700 font-bold">Admin</div>
            <div className="text-lg font-bold text-slate-900">411TechSavvy</div>
          </div>
        </div>

        <h1 className="mt-6 text-2xl font-extrabold text-slate-900">Sign in to continue</h1>
        <p className="mt-2 text-sm text-slate-600">
          Access the admin dashboard to view leads, chat sessions and stats. Only authorized
          Google accounts can sign in.
        </p>

        {user && !user.is_admin && (
          <div className="mt-5 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
            You&rsquo;re signed in as <strong>{user.email}</strong> but this account is not on the admin
            allowlist.
          </div>
        )}

        <Button
          onClick={login}
          className="mt-6 w-full h-12 bg-slate-900 hover:bg-slate-800 text-white font-semibold text-base"
        >
          <LogIn className="mr-2 h-5 w-5" /> Sign in with Google
        </Button>

        <Link
          to="/"
          className="mt-4 flex items-center justify-center gap-1 text-sm text-slate-500 hover:text-slate-800"
        >
          <ArrowLeft className="h-3.5 w-3.5" /> Back to website
        </Link>
      </div>
    </div>
  );
}
